export default "__VITE_ASSET__InzJ8hSv__"